module.exports = "/_next/static/images/1ec78061115e4af951e2f5cd8d70aedc-pen@tablet768.jpg.webp";